import type { Series } from '@/mocks/series';

export type StatusKey = Series['status'];

export const statusInfo: Record<
  StatusKey,
  { text: string; chip: string; dot: string; badge: string }
> = {
  ongoing: { text: '追更中', chip: 'bg-primary-100 text-primary-700', dot: 'bg-primary-500', badge: 'bg-primary-500' },
  finished: { text: '已完结', chip: 'bg-accent-100 text-accent-800', dot: 'bg-accent-500', badge: 'bg-accent-500' },
  coming: { text: '待开播', chip: 'bg-secondary-100 text-secondary-900', dot: 'bg-secondary-500', badge: 'bg-secondary-500' },
};

export function formatHeat(h: number): string {
  return `${(h / 10).toFixed(1)}万`;
}
